<template>
	<div class="page">
		<header>
			<h1>
				Niveau
				<br />de finition
			</h1>
		</header>
		<article>
			<div class="gauche">
				<h2>
					Clés
					<br />en main
				</h2>
				<div
					:class="finition == 'Clés en main' ? 'selected option' : 'option'"
					id="clesenmain"
					@click="active('clesenmain', 'Clés en main')"
				>
					<img src="../assets/04-clesenmains.png" />
				</div>
			</div>
			<div class="gauche">
				<h2>
					Prêt à
					<br />décorer
				</h2>
				<div
					:class="finition == 'Prêt à décorer' ? 'selected option' : 'option'"
					id="pret"
					@click="active('pret', 'Prêt à décorer')"
				>
					<img src="../assets/04-pretadecorer.png" />
				</div>
			</div>
			<div class="droite">
				<h2>
					Hors d'eau,
					<br />hors d'air
				</h2>
				<div
					:class="finition == 'Hors air/eau' ? 'selected option' : 'option'"
					id="horsair"
					@click="active('horsair', 'Hors air/eau')"
				>
					<img src="../assets/04-horsair.png" />
				</div>
			</div>
		</article>
		<footer>
			<router-link to="/surface" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
			<router-link v-if="ready || finition.length > 1" to="/garage" class="button medium">
				Garage
				<i class="fa fa-angle-right"></i>
			</router-link>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "Finition",
		components: {},
		data() {
			return {
				ready: false
			};
		},
		computed: {
			finition() {
				return this.$store.state.finition;
			}
		},
		methods: {
			active(element, value) {
				this.ready = true;
				this.$store.commit("setFinition", value);
				var options = document.querySelectorAll(".option");
				var cible = document.getElementById(element);
				options.forEach(el => {
					el.classList.remove("selected");
				});
				cible.classList.add("selected");
			}
		},
		mounted() {
			this.$store.commit("setTimer", 60);
		}
	};
</script>

<style lang="less">
</style>